// Filename-safe slug helper. Strips non-alphanumerics, collapses runs
// to a single dash, trims edge dashes. Returns `fallback` when the
// stripped result is empty (whitespace-only / all-punctuation input).
//
// **Why a helper, not inline.** Originally hoisted at P-034 (D-096) at
// the 3-use threshold across the JSON download pair + the HTML
// download. After the JSON pair drop (P-037.31 §C), the surviving
// consumers are:
// - email-editor-output.tsx — `${filenameSlug(email.name, 'email')}-
//   ${todayIso()}.html` (HTML download, P-033).
// - firebase-storage.ts — image-upload object key derivation
//   (P-FS-04 / D-119).
//
// **Why parameterize the fallback.** Each consumer wants a different
// semantic default (`'email'` for HTML downloads, `'image'` for
// uploads); the default `'untitled'` covers any future caller.
//
// **No XSS path.** The slug never reaches HTML — it's the value of an
// `<a download>` attribute (browser treats it as an opaque string for
// the Save dialog) or a Storage-bucket object key.

export function filenameSlug(name: string, fallback: string = 'untitled'): string {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug === '' ? fallback : slug
}
